module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "empty-state-try-screen-2.97e7b8f1.mp4";